var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-store"},[_c('Badge',{attrs:{"dot":"","count":_vm.countComputed}},[_c('Button',{attrs:{"type":"text"},on:{"click":_vm.openErrorLoggerPage}},[_c('Icon',{attrs:{"size":20,"type":"ios-bug"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }